import { get } from './index.js'



// 查询结果信息
export const searchQuery = (params = {}) => {
  return get('/search/query', params)
}


export default {
  searchQuery
} 